<template>
  <div class="has-text-centered">
    <img
      src="static/images/404-error.jpg"
      alt=""
      width="auto"
    >
    <h5 class="title is-5 has-text-asure">
      We were unable to find the page you were looking for. We apologize.
    </h5>
    <h5>
      You will be redirected to home page in {{ timer }}
    </h5>
  </div>
</template>

<script>
  export default {
    name: 'FourZeroFour',
    data () {
      return {
        timer: 5,
        timeout: ''
      }
    },
    mounted () {
      this.counter()
    },
    beforeDestroy () {
      clearTimeout(this.timeout)
    },
    methods: {
      counter () {
        clearTimeout(this.timeout)
        if (this.timer === 0) {
          window.location.href = '/'
        }
        this.timeout = setTimeout(() => {
          this.timer--
          return this.counter()
        }, 1000)
      }
    }
  }
</script>